export default __webpack_public_path__ + "static/media/icon-aro-transaction.16f98ab1.svg";